import apiClient from "../services/apiClient";
import { unwrapApiResponse } from "./unwrapApiResponse";

export async function submitHostingOrder(payload) {
  const { data } = await apiClient.post("/api/hosting/orders", payload);
  return unwrapApiResponse({ data });
}
